


import TiwiMixin from '../../mixins/TiwiMixin';
import ContentCard from '../ContentCard';

export default {
  mixins: [TiwiMixin],
  components: {
    ContentCard,
  },
  props: {
    userId: {
      required: true,
      default: 0
    },
    postType: {
      required: false,
      default: 'story'
    },
    
  },
  data() {
    return {
      posts: [],
      showDrafts: false
    }
  },
  mounted: function () {
    // console.log(this.userId);
  },
  computed: {
    sameUser: function () {
      return this.user && (this.user.ID == this.userId);
    },
    comp_posts: function () {
      return this.posts.map((post) => {
        if (post.status == 'draft') {
          post.url = this.config?.pages.new_story + '?story_id=' + post.ID;
        } 
        if (!post.image) {
          post.image = this.config?.story_empty_cover?.url;
        }
        return post;
      });
    }
  },
  methods: {
    getStories: function () {
      const self = this;
      const drafts = this.showDrafts && (this.user.ID == this.userId);

      var post_data = {
        posts_per_page: 100,
        post_type: this.postType,
        author: this.userId,
        post_status: drafts ? 'draft' : 'publish'
      };

      this.api.post('posts', post_data)
        .then((response) => {
          if (response.data.success) {
            self.posts = response.data.posts;
          } else {
            self.toast.error(response.data.message);
          }

        })
        .catch((error) => {
          self.toast.error('Errore nella richiesta');
        })
    },
  },
  watch: {
    user: function (user) {
      if (user) {
        this.getStories();
      }
    },
    showDrafts: function () {
      this.getStories();
    }
  }
}
